// extracted by mini-css-extract-plugin
export default {"container":"ObgynPage_container__IODAE","screeningHeader":"ObgynPage_screeningHeader__P22nt"};